import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/maintenance',
    children: [
      { path: 'home', name: 'maintenance-home', component: () => import('@/modules/maintenance/MaintenanceHome.vue') },
      { path: 'requests', name: 'maintenance-requests', component: () => import('@/modules/maintenance/MaintenanceHome.vue') },
      { path: 'spare-parts', name: 'maintenance-spare', component: () => import('@/modules/maintenance/SparePartsList.vue') }
    ]
  }
]

export default routes
